export default "__VITE_ASSET__6feaf420__"